const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/associations/$associationId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { Link, createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/associations/$associationId")({
  beforeLoad: args => requirePermission(Permissions.Associations.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Tab = "overview" | "invitations" | "pricing";